export var importUserSchema = {
  type: 'object',
  properties: {
    template: {
      type: 'array',
      items: {
        type: 'object',
        properties: {
          name: {
            type: 'string'
          },
          url: {
            type: 'string'
          }
        }
      },
      default: [{
        name: '用户导入模板.xlsx',
        url: 'https://api.micun.com/assistant/oss/download/object/v1?objectName=upload%2F2024%2F7%2F1%2FpxeFhmo9q3L0x8c6bykXL%2F%E7%94%A8%E6%88%B7%E5%AF%BC%E5%85%A5%E6%A8%A1%E7%89%88.xlsx'
      }],
      title: '批量导入模板',
      'x-read-only': true,
      'x-decorator': 'FormItem',
      'x-component': 'Upload'
    },
    upload: {
      type: 'array',
      items: {
        type: 'object',
        properties: {
          name: {
            type: 'string'
          },
          url: {
            type: 'string'
          }
        }
      },
      required: true,
      title: '导入文件',
      'x-decorator': 'FormItem',
      'x-component': 'Upload',
      'x-component-props': {
        maxCount: 1,
        mode: 'file'
      }
    }
  }
};
export var importShopSchema = {
  type: 'object',
  properties: {
    template: {
      type: 'array',
      items: {
        type: 'object',
        properties: {
          name: {
            type: 'string'
          },
          url: {
            type: 'string'
          }
        }
      },
      default: [{
        name: '门店导入模板.xlsx',
        url: 'https://api.micun.com/assistant/oss/download/object/v1?objectName=upload%2F2024%2F7%2F1%2FB4GY7CQKT1oEvIseSI2RF%2F%E9%97%A8%E5%BA%97%E5%AF%BC%E5%85%A5%E6%A8%A1%E7%89%88.xlsx'
      }],
      title: '批量导入模板',
      'x-read-only': true,
      'x-decorator': 'FormItem',
      'x-component': 'Upload'
    },
    upload: {
      type: 'array',
      items: {
        type: 'object',
        properties: {
          name: {
            type: 'string'
          },
          url: {
            type: 'string'
          }
        }
      },
      required: true,
      title: '导入文件',
      'x-decorator': 'FormItem',
      'x-component': 'Upload',
      'x-component-props': {
        maxCount: 1,
        mode: 'file'
      }
    }
  }
};